import Chart from 'chart.js'
import dateFns from 'date-fns'

export default class GrowthLossChart {
  constructor() {
    const ctx = document.getElementById('growth-loss-chart').getContext('2d')
    let growthImage = new Image(20, 20)
    growthImage.src = '/static/i/arrow_up.png'
    let lossImage = new Image(20, 20)
    lossImage.src = '/static/i/arrow_down.png'
    this.chartLine = new Chart(ctx, {
      type: 'line',
      data: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: 'rgba(42, 10, 78, 0)',
            borderColor: 'rgba(42, 10, 78, 1.0)',
            borderWidth: 2,
            fill: 0,
            pointBorderColor: 'rgba(42, 10, 78, 1.0)',
            pointBackgroundColor: 'rgba(255,255,255,1)',
            pointRadius: 5,
            pointBorderWidth: 2,
            cubicInterpolationMode: 'monotone',
            // lineTension: 0.33,
            spanGaps: true,
            xAxisId: 'A'
          },
          {
            data: [],
            backgroundColor: 'rgba(42, 10, 78, 0)',
            borderColor: 'rgba(42, 10, 78, 0)',
            borderWidth: 2,
            fill: 0,
            pointBorderColor: 'rgba(42, 10, 78, 1)',
            pointBackgroundColor: 'rgba(42, 10, 78, 1)',
            pointRadius: 5,
            pointBorderWidth: 2,
            // cubicInterpolationMode: 'monotone',
            lineTension: 0.33,
            spanGaps: true,
            xAxisId: 'B'
          }
        ]
      },
      options: {
        animation: { duration: 0 },
        legend: { display: false },
        tooltips: {
          enabled: false,
          filter: filterCallback,
          callbacks: { label: tooltipsCallback },
          custom: setToolTip
        },
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: ticksCallback,
                padding: 10,
                fontFamily: "'pitch-sans-web-regular'"
              },
              gridLines: { drawBorder: false }
            }
          ],
          xAxes: [
            {
              id: 'A',
              gridLines: { display: false, drawBorder: false },
              ticks: {
                padding: 20,
                fontFamily: "'pitch-sans-web-regular'",
                callback: monthsTicksCallback
              }
            },
            {
              id: 'B',
              gridLines: { display: false, drawBorder: false },
              ticks: { padding: 0, callback: growthLossTicksCallback }
            }
          ]
        }
      },
      plugins: [
        {
          afterUpdate: chart => {
            chart.config.data.datasets[1].data.forEach((x, i) => {
              x = x - 2
              if (x >= 0) {
                chart.config.data.datasets[1]._meta[
                  Object.keys(chart.config.data.datasets[1]._meta)[0]
                ].data[i]._model.pointStyle = growthImage
              } else {
                chart.config.data.datasets[1]._meta[
                  Object.keys(chart.config.data.datasets[1]._meta)[0]
                ].data[i]._model.pointStyle = lossImage
              }
            })
            // offset arrows to between datapoints
            if (
              chart.config.data.datasets[1]._meta[
                Object.keys(chart.config.data.datasets[1]._meta)[0]
              ].data[1]
            ) {
              var offset =
                (chart.config.data.datasets[1]._meta[
                  Object.keys(chart.config.data.datasets[1]._meta)[0]
                ].data[1]._model.x -
                  chart.config.data.datasets[1]._meta[
                    Object.keys(chart.config.data.datasets[1]._meta)[0]
                  ].data[0]._model.x) /
                2
              chart.config.data.datasets[1]._meta[
                Object.keys(chart.config.data.datasets[1]._meta)[0]
              ].data.forEach(i => {
                var model = i._model
                model.x -= offset
                model.controlPointNextX -= offset
                model.controlPointPreviousX -= offset
              })
            }
          }
        }
      ]
    })
  }

  updateGrowthLossData(data) {
    let total = data.reduce((acc, cur) => {
      return acc + Number(Object.values(cur)[0])
    }, 0)
    const dataset = data.map(x => {
      if (x.holdings === '') {
        return { holding: NaN, total: total }
      } else {
        return { holding: x.holdings, total: total }
      }
    })

    let lastHolding = 0
    let growthLoss = dataset.map((x, i) => {
      if (i === 0) {
        return NaN
      }
      let growth = 0
      if (x.holding === '') {
        return growth
      } else {
        growth = Number(x.holding) - lastHolding
        lastHolding = Number(x.holding)
        return growth
      }
    })

    let labels = data.map((x, i) => {
      let date = new Date(x.month)
      if (i === 0) {
        return {
          month: dateFns.format(date, 'MM/YY'),
          growthLoss: ''
        }
      }
      return {
        month: dateFns.format(date, 'MM/YY'),
        growthLoss: Math.round(growthLoss[i] / 1000, 0) + 'K'
      }
    })
    const growthLossAmount = document.querySelector('.growth-loss__amount')
    let growthTotal = Number(
      dataset[dataset.length - 1].holding - dataset[0].holding
    ).toLocaleString(undefined, {
      maximumFractionDigits: 0
    })
    let growthImage = '/static/i/arrow_up.png'
    if (growthTotal < 0) {
      growthImage = '/static/i/arrow_down.png'
    }
    growthLossAmount.innerHTML = `$${growthTotal} <img class="growth-loss__image" src="${growthImage}" />`
    this.chartLine.data.labels = labels
    this.chartLine.data.datasets[0].data = dataset.map(x => x.holding)
    let maxGrowth = growthLoss.reduce((acc, cur) => {
      if (!acc) {
        acc = 0
      }
      let largest = Number(acc)
      if (Number(cur) > Number(acc)) {
        largest = Number(cur)
      }
      return largest
    })
    this.chartLine.data.datasets[1].data = growthLoss.map(x => {
      // Normalise data and offset it slightly
      return Number(x) / maxGrowth + 2
    })
    this.chartLine.update()
  }
}

const filterCallback = tooltipItem => {
  return tooltipItem.datasetIndex === 0
}

const monthsTicksCallback = (value, index, values) => {
  return value.month
}

const growthLossTicksCallback = (value, index, values) => {
  return value.growthLoss
}

const ticksCallback = (value, index, values) => {
  let roundedValue = value / 1000000
  return Math.round(roundedValue * 100, 0) / 100 + 'M'
}

const tooltipsCallback = (tooltipItem, data) => {
  const index =
    tooltipItem.datasetIndex === undefined
      ? tooltipItem.index
      : tooltipItem.datasetIndex
  const itemData = data.datasets[index]
  // Return custom data to tooltip, these will be available inside the tooltip.body
  return {
    id: data.id,
    // pictureUrl: itemData.pictureUrl,
    datasetIndex: tooltipItem.datasetIndex,
    label: itemData.label,
    value: tooltipItem.yLabel,
    xLabel: tooltipItem.xLabel,
    percent: data.percent
  }
}

const setToolTip = tooltip => {
  // Tooltip Element
  const tooltipEl = document.getElementById('growth-loss-chart-chartjs-tooltip')

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0
    return
  }

  // Set caret Position
  tooltipEl.classList.remove('above', 'below', 'no-transform')
  if (tooltip.yAlign) {
    tooltipEl.classList.add(tooltip.yAlign)
  } else {
    tooltipEl.classList.add('no-transform')
  }

  function getBody(bodyItem) {
    return bodyItem.lines
  }

  // Set Text
  if (tooltip.body) {
    var bodyLines = tooltip.body.map(getBody)

    let innerHtml = `<div>
        <div class="tooltip__body">`

    bodyLines.forEach((body, i) => {
      tooltipEl.dataset.datasetindex = body[0].datasetIndex
      innerHtml += `<div class="tooltip__body--text tooltip__top">$${Number(
        body[0].value
      ).toLocaleString(undefined, {
        maximumFractionDigits: 0
      })}</div>`
    })
    innerHtml += `</div>
                </div>`

    // var tableRoot = tooltipEl.querySelector('table')
    tooltipEl.innerHTML = innerHtml
  }

  const chart = document.getElementById('growth-loss-chart')
  let height = chart.style.height.slice(0, chart.style.height.indexOf('px'))
  height = height - 20
  // adjusting for ticks padding
  if (tooltip.body && tooltip.body.length > 0) {
    tooltipEl.style.opacity = 1
  }
  tooltipEl.style.position = 'absolute'
  tooltipEl.style.left = tooltip.caretX + 'px'
  tooltipEl.style.top = tooltip.caretY + 'px'
  tooltipEl.style.height = height - tooltip.caretY + 'px'
  tooltipEl.style.padding = tooltip.yPadding + 'px ' + tooltip.xPadding + 'px'
}



// WEBPACK FOOTER //
// ./assets/j/src/charts/growth_loss.js